/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, mediaQuery } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : ADDON CONTROLLER : STYLES --------------- ++++++++++ */
export default theme => ({
  addoncontroller: {
    maxWidth: pxToEm(900),
    padding: pxToEm(24),
    minHeight: pxToEm(128),
    background: 'rgb(255, 255, 255)',
    borderRadius: '4px',
      display: 'flex',
      alignItems: 'flex-start',
      '& .cardinner': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        '& .titletoggle': {
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: pxToEm(24),
          '& .toggle': {
            width: pxToEm(40),
            height: pxToEm(22),
            '&.active-false .ball': {
              left: '0.20em'
            },
            '& .ball': {
              height: pxToEm(18),
              width: pxToEm(18)
            }
          },
          '& .title': {
            fontWeight: 'bold',
            color: 'rgb(6, 43, 117)',
            fontSize: pxToEm(16)
          }
        },
        '& .description': {
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: pxToEm(14),
          '& .descriptiontext': {
            position: 'relative',
            fontWeight: 'normal',
            color: 'rgb(130, 149, 186)',
            maxWidth: pxToEm(620),
            height: 'auto',
            textOverflow: 'ellipsis',
            paddingRight: pxToEm(5),
            transition: 'max-height .4s',
            textAlign: 'left'
          },
          '& .cta': {
            fontWeight: '500',
            color: 'rgb(20, 148, 244)',
            marginTop: pxToEm(10)
          },
          '& .cta.name-edit': {
            fontWeight: 500,
            height: '32px',
            fontSize: '14px',
            opacity: 0,
            alignSelf: 'flex-end',
            animationName: 'fadeInUp',
            animationDelay: '.1s',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            '& .icon i': {
              fontSize: pxToEm(14)
            }
          }
        }
      },
      '& img': {
        margin: `${pxToEm(8)} ${pxToEm(32)} 0 ${pxToEm(8)}`
      }
  },

  // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
  [mediaQuery.thinnest]: {
    addoncontroller: {
      height: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      textAlign: 'left',
      display: 'block',
      '& .cardinner': {
        '& .description': {
          display: 'block',
          '& .descriptiontext': {
            maxHeight: '100%',
            paddingBottom: pxToEm(12)
          }
        }
      }
    }
  }
});
